export const LANGUAGE_MAP = {
  arabic: 'ar',
  danish: 'da',
  german: 'de',
  greek: 'el',
  english: 'en',
  spanish: 'es',
  finnish: 'fi',
  french: 'fr',
  hebrew: 'he',
  hindi: 'hi',
  italian: 'it',
  japanese: 'ja',
  korean: 'ko',
  malay: 'ms',
  dutch: 'nl',
  norwegian: 'no',
  polish: 'pl',
  portuguese: 'pt',
  russian: 'ru',
  swedish: 'sv',
  swahili: 'sw',
  turkish: 'tr',
  chinese: 'zh'
}

export const LANGUAGE_OPTIONS = Object.entries(LANGUAGE_MAP).map(
  ([name, code]) => ({
    label: name.charAt(0).toUpperCase() + name.slice(1),
    value: code
  })
)

export const getLanguageLabelByCode = languageCode => {
  const languageName =
    Object.keys(LANGUAGE_MAP).find(key => LANGUAGE_MAP[key] === languageCode) ||
    'english'

  return languageName.charAt(0).toUpperCase() + languageName.slice(1)
}
